var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footer-main"},[_vm._v(_vm._s(this.text))])
}
var staticRenderFns = []

export { render, staticRenderFns }